export var getSimpleOptionsWidgets = function (query) {
    if (!query.interval)
        return ['metric'];
    return [];
};
